export default "__VITE_ASSET__zbfqNNCB__"